import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'

const AddAccountNameModal = ({ open, setOpen }) => {
    return (
        <div>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md text-left">
                                    <div>
                                        <div className='font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900'>Add account name</div>
                                        <div className='p-[16px_20px] border-b-[1px] border-[#ebeef1] bg-[#f6f8fa]'>
                                            <input type="text" placeholder='Company' className='input_focus_shadow text-[#a3acba] font-normal px-3 w-[80%] bg-white border-[#ebeef1] rounded-[6px] focus:outline-none h-[28px] text-[14px] border-[1px]' />
                                            <div className='text-[14px] mt-2'>You can also edit this in your <span className='text-[#625afa] font-semibold'>Account settings.</span></div>
                                        </div>
                                        <div className='font-semibold p-[16px_20px] flex justify-end border-b-[1px] border-[#ebeef1] text-base text-gray-900 gap-2'>
                                            <button className='border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-semibold p-[0_8px]' onClick={() => setOpen(false)}>Cancel</button>
                                            <button className='border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]'>Add name</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default AddAccountNameModal